import { render, staticRenderFns } from "./ProcedureDetailsList.vue?vue&type=template&id=3244b37a&scoped=true&"
import script from "./ProcedureDetailsList.vue?vue&type=script&lang=js&"
export * from "./ProcedureDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureDetailsList.vue?vue&type=style&index=0&id=3244b37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244b37a",
  null
  
)

export default component.exports